import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState, } from 'react';
import { themes, DEFAULT_THEME, } from '../../constants/themes/themes';
export const ThemeProviderContext = createContext({
    theme: themes[DEFAULT_THEME],
    setTheme: () => null,
});
export const ThemeProvider = ({ children, theme }) => {
    const [currentTheme, setCurrentTheme] = useState(themes[DEFAULT_THEME]);
    useEffect(() => {
        theme && setTheme(theme);
    }, [theme]);
    const setTheme = (type) => setCurrentTheme(themes[type]);
    return (_jsx(ThemeProviderContext.Provider, { value: { theme: currentTheme, setTheme }, children: children }));
};
